import { ModalError } from './ModalError';

export default ModalError;
